import { SET_ERROR_LOG } from "./ErrorLogType";


const initialState = {
    errorLogs: {}    
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        
        case SET_ERROR_LOG:
            return {
                
                ...state, errorLogs : action.value
            }
     
        default:
            return state;
    }
};

export default reducer;
